import { render, staticRenderFns } from "./BankAccountAddress2.vue?vue&type=template&id=c4f57efc&scoped=true"
import script from "./BankAccountAddress2.vue?vue&type=script&lang=js"
export * from "./BankAccountAddress2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f57efc",
  null
  
)

export default component.exports